import { getWeek } from '@/lib/date-utils'
import VirtualizedDataTable from '@/components/zthd/virtualized-data-table'
import { forwardRef } from 'react'

export const TargetDays = [0, 3, 7, 14, 30, 45, 60, 90, 120, 150, 180]

export const baseSortedData = (dailyData, weekFilter, sorts) => {
  if (!sorts || sorts.length === 0) {
    return dailyData
  }

  dailyData.reduce((acc, item) => {
    const [dayIndex] = getWeek(item.install_date)
    if (dayIndex === Number(weekFilter)) {
      acc.push(item)
    }
    return acc
  }, [])

  const sorted = [...dailyData].sort((a, b) => {
    for (const sortItem of sorts) {
      const { code, order } = sortItem
      let aValue = a[code]
      let bValue = b[code]

      // Special handling for install_date as string comparison
      if (code === 'install_date') {
        aValue = String(aValue).replace(/-/g, '')
        bValue = String(bValue).replace(/-/g, '')
      }

      if (aValue === bValue) continue

      if (order === 'asc') {
        return aValue > bValue ? 1 : -1
      } else {
        return aValue < bValue ? 1 : -1
      }
    }
    return 0
  })
  return sorted
}

export const ROASDailyDataTable = forwardRef((props, ref) => {
  const { primaryKey = "install_date", ...restProps } = props
  return (
    <VirtualizedDataTable
      {...restProps}
      ref={ref}
      useVirtual={{
        horizontal: true,
        vertical: true,
      }}
      primaryKey={primaryKey}
      hasHeader
      isLoading={false}
      emptyCellHeight={50}
      components={{
        EmptyContent: () => (
          <div className="flex items-center justify-center h-24">
            <span className="text-muted-foreground">No data available</span>
          </div>
        ),
      }}
    />
  )
})
